<div class="container">
  <ng-container *ngIf="!loadIndicator; else loading">
    <div class="logo_image">
      <img *ngIf="globalService.langChosen === 'ar'"  src="assets/img/tecno-cup-ksa/Players-icon.png" class="img-responsive">
      <img *ngIf="globalService.langChosen === 'en'" src="../../../../../assets/img/tecno-cup-ksa/players-eng.png" class="img-responsive">
    </div>
    <div class="tab-content team"   [ngClass]="{engClass : globalService.langChosen === 'en'}" *ngIf="participants != 0; else nodata">
      <ng-container *ngFor="let participant of participants">
        <div class="team-block">
          <app-player-card-resuable  [backgroundImageBody]="' linear-gradient(90deg, rgba(22,191,253,1) 0%, rgba(2,100,250,1) 55%)'"
                                     [participant]="participant">
          </app-player-card-resuable>
        </div>
      </ng-container>
    </div>

  </ng-container>
  <ng-template #nodata>
    <div class="no-data " *ngIf="participants?.length==0">
      <h2>{{globalService.customLang.no_winners}}</h2>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>













